(()=> {
    document.addEventListener('DOMContentLoaded', () => {
        /* Get all of the Picture Block img elements with a data-src */
        let imagesToLoad = document.querySelectorAll("picture.picture-block img[data-src]");

        /* Sets an img src to the data-src, then removes data-src */
        const loadImageFromDataSrc = (image) => {
            let delay = image.classList.contains('above-the-fold-sm') ? window.PictureDelay ?? 0 : 0;
            setTimeout(() => {
                image.setAttribute("src", image.getAttribute("data-src"));
                image.onload = () => {
                    image.removeAttribute("data-src");
                };
            }, delay);
        };

        /* Setup global Intersection Observer and add Picture Block img to be observed */
        if ("IntersectionObserver" in window) {
            const observer = new IntersectionObserver((items, observer) => {
                items.forEach((item) => {
                    if (item.isIntersecting) {
                        loadImageFromDataSrc(item.target);
                        observer.unobserve(item.target);
                    }
                });
            });

            imagesToLoad.forEach((img) => {
                observer.observe(img);
            });
        } else {
            imagesToLoad.forEach((img) => {
                loadImageFromDataSrc(img);
            });
        }

        /* Setup global Picture Block Resize Observer */
        if (!window.PictureBlockResizeObserver) {
            window.PictureBlockResizeObserver = new ResizeObserver((entries) => {
                for (const entry of entries) {
                    if (entry.contentBoxSize) {
                        const width = entry.contentBoxSize[0].inlineSize;
                        const block = entry.target.parentElement.dataset.block;

                        const imgSelector = `img[data-block="${block}"]`;
                        const preview = document.querySelector(imgSelector);
                        if (preview)
                            preview.style.width = `${Math.floor(width)}px`;
                    }
                }
            });
        }

        /* Get all of the Picture Block img elements */
        const picImgs = document.querySelectorAll(`picture.picture-block img`);
        picImgs.forEach((picImg) => {
            picImg.addEventListener('load', (ev) => {
                const block = ev.target.parentElement.dataset.block;
                const imgSelector = `img[data-block="${block}"]`;
                const preview = document.querySelector(imgSelector);
                if (preview)
                    preview.classList.add('hide');

                ev.target.classList.add('show');
            });

            window.PictureBlockResizeObserver.observe(picImg);
        });
    });
}
)();